module.exports = __webpack_public_path__ + "distribution/img/bei3.bbf018f1.png";